module.exports = __webpack_public_path__ + "static/media/loading.bd9e930c.gif";